/**
 * "AI Generated / Dictation" generation type, shared by the PTP AI Scribe modal
 * and the QME Generate card. Filters the template catalog by the owning
 * generation_profile_sets.generation_mode — keep in sync with GENERATION_MODES
 * in document-llm-api generation-templates-query.dto.ts.
 */
export type GenerationMode = 'ai_generated' | 'dictation';

export const DEFAULT_GENERATION_MODE: GenerationMode = 'ai_generated';

export const GENERATION_MODE_OPTIONS: ReadonlyArray<{
  value: GenerationMode;
  label: string;
}> = [
  { value: 'ai_generated', label: 'AI Generated' },
  { value: 'dictation', label: 'Dictation' },
];
